<template>
	<div>
		<div id="page-header">
			<top-link />
			<div class="all_goods">
				
			</div>
			
			<div class="part">
				<div class="part_title">最新热卖产品</div>
				<div>
					<img src="../../assets/images/shop_bg2.jpg" />
				</div>
			</div>
			
			<div>
				<div>
					<div class="part_title"></div>
					<img src="../../assets/images/shop_bg3.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import TopLink from '../toplink/index.vue'
	
	export default {
		components: {
			TopLink
		},
		data() {
			return {
				activeName: 'second',
				linkQrcodeVisable: false
			};
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			}
		}
	};
</script>

<style lang="scss" scoped>
	li {
		list-style-type: none;
	}

	#app {
		font-family: Helvetica, sans-serif;
		text-align: center;

		#page-header {
			.all_goods{
				width: 1920px;
				height: 740px;
				background-image: url(../../assets/images/shop_bg01.jpg);
				background-repeat: no-repeat;
			}
			
			.part_title{
				padding: 50px 0;
				font-size: 36px;
				font-weight: 500;
				color: #555;
			}
		}


	}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue